<div class="row">
  <div class="col-5">
    <ui-input-loader-wrap [loading]="busy">
      <input class="form-control"
             [placeholder]="'common.postNumberPlaceholder_' + country.code | translate"
             [inputMask]="'postNumber'"
             [inputMaskArgs]="{countryCode: country.code}"
             (ngModelChange)="onPostNumberUpdated($event)"
             [(ngModel)]="postNumber">
    </ui-input-loader-wrap>
  </div>

  <div class="col-7">
    <div class="form-group">
      <input class="form-control"
             [ngModel]="cityName"
             disabled>
    </div>
  </div>
</div>

<ng-container *ngIf="cityName && cityName !== NOT_FOUND">
  <div class="mt-1" *ngIf="deliveryPrices">
    <h5 class="font-xl">{{'orderProcess.cakesOverview.delivery.times' | translate}}</h5>

    <delivery-days-info
      [deliveryPrices]="deliveryPrices"
      [currencySymbol]="country.currencySymbol"
    ></delivery-days-info>

    <custom-delivery-times
      class="d-block mt-3"
      *ngIf="deliveryScheduleOverrides?.length"
      [deliveryScheduleOverrides]="deliveryScheduleOverrides"
      [currencySymbol]="country.currencySymbol"
    ></custom-delivery-times>
  </div>

  <div class="mt-3" *ngIf="deliveryPrices && showNext">
    <button class="btn btn-pink px-5"
            (click)="onNext.emit(cityLocation)"
            [translate]="'common.continue'">
      Continue
    </button>
  </div>

  <div *ngIf="isDeliveryPricesReady && !deliveryPrices && checkPostNumberLength(postNumber)"
       class="mt-3 fw-bold">
    {{'orderProcess.cakesOverview.delivery.noDeliveryAvailable' | translate}}&nbsp;{{postNumber}}
  </div>
</ng-container>
